export default __webpack_public_path__ + "static/media/explore_page_hero.3179fa2b.jpg";